import { observer } from "mobx-react-lite"

import { useScaleApplication } from "@/domains/application/use-scale-application"
import { MetaData } from "@/domains/common/layout/metadata"
import { PageContainer } from "@/domains/common/layout/page-container"
import { SwapCardContainer } from "@/domains/swap/components/composables/swap-card-container"

export default observer(function Trade() {
  const scaleApp = useScaleApplication()

  // This will now reactively update when slippage changes
  const slippageTolerance = `${scaleApp.Settings.slippage}%`

  // Handle swap/wrap/unwrap action - orchestrator routes based on token pair
  const onSwapAction = async (): Promise<void> => {
    try {
      await scaleApp.Swap.Orchestrator.execute(scaleApp.getWagmiConfig())
    } catch (error) {
      console.error("Execution error", error)
    }
  }

  const title = "Swap"

  return (
    <PageContainer>
      <MetaData title={title} />
      {/* <PageTitle title={title} subTitle="Our new engine delivers the best rates for your trades." /> */}

      <SwapCardContainer
        quoteStore={scaleApp.Swap.QuoteStore}
        inputStore={scaleApp.Swap.InputStore}
        executionStore={scaleApp.Swap.ExecutionStore}
        onSwapAction={onSwapAction}
        slippageTolerance={slippageTolerance}
      />
    </PageContainer>
  )
})
